import { useCallback, useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { api, toastErr } from "@/lib/api";
import { num } from "@/lib/format";

// Profiles hidden from ONE Dashboard box (agency-wide, owners/managers): nothing else changes.
export function useHidden(box) {
  const [h, setH] = useState({ unread: [], paid: [], can_edit: false });
  useEffect(() => { api.get("/dashboard/hidden-profiles").then((r) => setH(r.data)).catch(() => {}); }, []);
  const set = useCallback(async (account_id, hidden) => {
    try { const r = await api.put("/dashboard/hidden-profiles", { box, account_id, hidden }); setH(r.data); } catch (e) { toastErr(e); }
  }, [box]);
  return { hidden: h[box] || [], canEdit: h.can_edit, set };
}

export const HideBtn = ({ onClick, testid }) => (
  <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(); toast.success("Nascosto dalla Dashboard"); }} title="Nascondi dalla Dashboard"
    className="absolute right-1.5 top-1.5 rounded p-1 text-slate-600 transition-colors hover:text-white" data-testid={testid}><EyeOff className="h-3.5 w-3.5" /></button>
);

export function HiddenRow({ items, value, canEdit, onShow, testid }) {
  if (!items.length) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-slate-500" data-testid={testid}>Profili nascosti ({items.length}):
      {items.map((p) => <span key={p.id} className="flex items-center gap-1">@{p.username} <span className="num">{num(value(p))}</span>
        {canEdit && <button onClick={() => onShow(p.id)} className="flex items-center gap-0.5 text-slate-400 hover:text-white" data-testid={`${testid}-show-${p.username}`}><Eye className="h-3 w-3" />Mostra</button>}</span>)}
    </div>
  );
}
